import { render, staticRenderFns } from "./TeacherCourseProjects.vue?vue&type=template&id=0d3d6c7a&scoped=true&"
import script from "./TeacherCourseProjects.vue?vue&type=script&lang=js&"
export * from "./TeacherCourseProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d6c7a",
  null
  
)

export default component.exports